import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import Prepayment from '../../models/Prepayment'

export interface PrepaymentListState extends PaginatedApiState {
  prepayments?: Prepayment[]
}

const PrepaymentList = (state: PrepaymentListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<PrepaymentListState>('PREPAYMENT_LIST')(state, action)
  }
}

export default PrepaymentList
